import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import Invite from './pages/invite';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/invite" replace />} />
        <Route path="/invite" element={<Invite />} />
        <Route path="*" element={<Navigate to="/invite" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
